import { colors } from 'theme'

export const defaultThemeStyles: { textMain: string } = {
    textMain: colors.black,
}
